export const serializeFuseResult = (fuseData) => {
  return fuseData.map((d) => d["item"]);
};
